<template>
  <div id="app">
        <transition name="fade" mode="out-in">
            <router-view :key="key"></router-view>
        </transition>
    </div>
</template>

<script>
export default {
  name: 'App',
  computed:{
	    key(){
	        return this.$route.path + Math.random();
	    }
  },
}
</script>

<style>
 body {
        margin: 0;
        padding: 0;
        font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
        font-size: 14px;
        -webkit-font-smoothing: antialiased;
    }

    #app {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
    }

    .el-submenu [class^=fa] {
        vertical-align: baseline;
        margin-right: 10px;
    }

    .el-menu-item [class^=fa] {
        vertical-align: baseline;
        margin-right: 10px;
    }

    .toolbar {
        background: #f2f2f2;
        padding: 10px;
        margin: 10px 0;
    }
    .el-form-item {
        margin-bottom: 10px;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: all 0.2s ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0;
    }
    .color-success {
    color:#67c23a
    }
    .color-warning {
    color:#e6a23c
    }
    .color-danger {
    color:#f56c6c
    }
    .color-info {
    color:#909399
    }
</style>



// WEBPACK FOOTER //
// src/App.vue